import { VALIDATION_METHODS, VALIDATION_ERRORS } from '../../state/stateExtension'
export const getprivacyfabrick = () => {
    return {
        widgets: [
            {
                code: '19503',
                name: 'PRIVACY_FABRICK',
                bundleLink: null,
                bundleCode: null,
                group: 'PRIVACY_FABRICK',
                groupTitle: '',
                components: [
                    {
                        id:'PRIVACY_FABRICK',
                        name: 'FABCHECKBOX',
                        active:true,
                        type: 'privacyfabrick',
                        position:'3',
                        value:'',
                        cleanName: '',
                        // validations: {
                        //   isRequired: true,
                        //   default: [
                        //     {
                        //       validate: VALIDATION_METHODS.bool,
                        //       getErrorMessage: VALIDATION_ERRORS.filled
                        //     }
                        //   ]
                        // },
                        status: [],
                        errorMessage: [],
                      }
                ],
                active:true,
                status: [],
                errorMessage: []
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./state/static/privacyfabrick.js